/* eslint-disable @typescript-eslint/no-explicit-any */
import ExcelJS from 'exceljs'

interface ExcelData {
  header: string[]
  properties: string[]
  array: Record<string, any>[]
}

const sheetName = 'Hoja 1'

async function generateExcel(
  header: string[],
  properties: string[],
  name: string,
  array: Record<string, any>[]
): Promise<ArrayBuffer> {
  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet(name)

  const headerRow = sheet.addRow(header)
  headerRow.font = { bold: true, name: 'Calibri', size: 12 }
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE0E0E0' }
  }
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

  array.forEach(element => {
    const row: (string | number | null)[] = []
    properties.forEach(itemProperty => {
      const value = itemProperty
        .split('.')
        .reduce((obj, key) => obj?.[key], element)
      row.push(value as unknown as string | number | null)
    })
    sheet.addRow(row)
  })

  sheet.columns.forEach((column: any, index: number) => {
    let maxLength = header[index]?.length || 10
    column.eachCell?.({ includeEmpty: false }, (cell: any) => {
      const cellValue = cell.value?.toString() || ''
      maxLength = Math.max(maxLength, cellValue.length)
    })
    column.width = Math.min(maxLength + 2, 50)
  })

  const buffer = await workbook.xlsx.writeBuffer()
  return buffer
}

export const getExcel = async (
  values: ExcelData,
  nameExcel: string
): Promise<void> => {
  const { header, properties, array } = values

  try {
    const buffer = await generateExcel(header, properties, sheetName, array)

    const file = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    const fileURL = URL.createObjectURL(file)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.href = fileURL
    a.download = `${nameExcel}.xlsx`
    a.click()

    document.body.removeChild(a)
    URL.revokeObjectURL(fileURL)
  } catch (error) {
    console.error('Error al generar el archivo Excel:', error)
    throw error
  }
}
